import styled from 'styled-components';

const SortByOption = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  width: 225px;
  height: 29px;
  font-size: 13px;
  line-height: 15px;
  text-transform: uppercase;
  font-family: "Avenir Light", "Arial", sans-serif;
  letter-spacing: 1px;
  font-weight: 900;
  text-decoration: none;
  background-color: ${({ selected }) => (selected ? 'rgb(245, 245, 245)' : '#000')};
  color: ${({ selected }) => (selected ? '#000' : '#FFF')};
  cursor: pointer;
  &:hover {
    background-color: rgb(245, 245, 245);
    color: #000;
  }
`;

export default SortByOption;
